var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowThickLeft = function SvgArrowThickLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.761 22.14 7.623 12 17.755 1.87c.21-.203.327-.478.332-.785a1.098 1.098 0 0 0-.681-1.005 1.082 1.082 0 0 0-1.18.245L5.318 11.232A1.08 1.08 0 0 0 5 12c0 .29.112.564.318.77l10.9 10.9a1.094 1.094 0 0 0 1.203.248 1.09 1.09 0 0 0 .668-1.027v-.008a1.075 1.075 0 0 0-.328-.743"
  })));
};
export { SvgArrowThickLeft as ReactComponent };